import React from 'react';
import NotAvailable from '../Common/NotAvailable';

interface ProviderServicesSectionProps {
  services: string[];
}

const ProviderServicesSection: React.FC<ProviderServicesSectionProps> = ({ services }) => {
  return (
    <section className="mb-8">
      <h3 className="font-['Ovo'] text-xl text-[#1f1f1f] uppercase mb-4">SERVICES</h3>
      {services.length === 0 ? (
        <NotAvailable className="text-base" />
      ) : (
        <div className="flex flex-wrap gap-2">
          {services.map((service, index) => (
            <span
              key={index}
              className="px-4 py-2 bg-white border border-[#c6a664] text-sm font-['Open_Sans'] text-[#1f1f1f] rounded"
            >
              {service}
            </span>
          ))}
        </div>
      )}
    </section>
  );
};

export default ProviderServicesSection;
